import React from 'react';
import axios from 'axios';

import Loading from '../../Loading'

import styles from '../../../styles/DynamicModal.module.css';

import IconContainer from '../../IconContainer';
import { ReactComponent as XIcon } from '../../../icons/x-close.svg';

export default function EditArbitrationCourt({ closeModal, id, action, onReloadTable }) {
    const [formInfo, setFormInfo] = React.useState({
        name: '',
        court_code: '',
    });
    const [status, setStatus] = React.useState('');
    const [loading, setLoading] = React.useState(false);



    const handleLogout = () => {
        localStorage.removeItem('token');
        window.location.href = '/';
    }
    React.useEffect(() => {
        if (action=='change') {
            const token = localStorage.getItem('token');
            if (!token) handleLogout();
            setStatus(<a><Loading type='inline' /></a>);

            axios.get(`/api/get-arbitration-court?id=${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }).then(response => {
                setFormInfo(response.data);
                setStatus(null);
            }).catch((error) => {
                console.error(error);
                setStatus(<a className='mainLabelError'>Не удалось загрузить данные региона. {error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
            }).finally(() => {
                setLoading(false);
            })
        } else {
            setLoading(false);
        }
    }, []);

    const handleChange = (field) => (e) => {
        const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;

        setFormInfo((prev) => ({ ...prev, [field]: value }));

        setStatus('Сохраните изменения');

        setErrorsForm((prevErrors) => {
        if (!prevErrors[field]) return prevErrors;
            const updatedErrors = { ...prevErrors };
            delete updatedErrors[field];
            return updatedErrors;
        });
    };

    const [errorsForm, setErrorsForm] = React.useState({});
        const validateForm = () => {
        const newErrors = {};
    
        if (!formInfo.name) {
            newErrors.name = 'Обязательное поле';
        }
        if (formInfo.name && (formInfo.name.length < 2 || formInfo.name.length > 150)) {
            newErrors.name = 'Значение не может быть меньше 2 и более 150 символов';
        }
    
        setErrorsForm(newErrors);
        if (Object.keys(newErrors).length > 0) {
            setStatus(<a className='mainLabelError'>Данные не сохранены. Проверьте корректность введенных полей</a>);
            return false;
        } else {
            return true;
        }
    };

    const addData = () => {
        const token = localStorage.getItem('token');

        axios.put('/api/add-new-arbitration-court', {
            name: formInfo.name,
            court_code: formInfo.court_code,
        }, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
        .then(() => {
            setStatus('Новые данные добавлены');
            onReloadTable();
            closeModal();
        })
        .catch((error) => {
            console.error(error);
            setStatus(<a className='mainLabelError'>Данные не сохранены. {error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
        }).finally(() => {
            setLoading(false);
        })
    };

    const changeData = () => {
        const token = localStorage.getItem('token');

        axios.put(`/api/change-arbitration-court`, {
            id: formInfo.id,
            court_code: formInfo.court_code,
        }, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then(() => {
            setStatus('Данные изменены');
            closeModal();
            onReloadTable();
        }).catch((error) => {
            console.error(error);
            setStatus(<a className='mainLabelError'>Данные не сохранены. {error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
        }).finally(() => {
            setLoading(false);
        })
    };

    const handleSave = () => {
        setLoading(true);
        setStatus(<a><Loading type='inline' /></a>);

        if (validateForm()) {
            if (action=='add') addData();
            if (action=='change') changeData();
        }
        setLoading(false);
    };


    return (
        <div className={styles.liningOver}>
            <div className={styles.lining} onClick={(e) => e.stopPropagation()}>
                <div className={styles.header}>
                    <h1>{action=='add' && 'Добавление'} 
                        {action=='change' && 'Редактирование'}
                        &nbsp;Арбитражного суда
                    </h1>
                    <IconContainer Icon={XIcon} onClick={closeModal} size = '20' color = 'black' className = '' />
                </div>
                <div className={styles.main}>
                    <div className='labelInputWrapper'>
                        <a className='label'>Название Арбитражного суда</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                                <input 
                                type='text' 
                                value={formInfo.name} 
                                onChange={handleChange('name')} 
                                className={errorsForm.name ? 'inputError' : ''}
                                placeholder='Официальное наименование без сокращений' 
                                minLength='' 
                                maxLength='150' 
                                disabled={loading || action=='change'}
                                required />
                                {errorsForm.name && <div className='errorUnderInput'>{errorsForm.name}</div>}
                                {action=='change' && <p className='description'>Изменение названия Арбитражного суда невозможно</p>}
                            </div>
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Код для автоподстановки</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                                <input 
                                type='text' 
                                value={formInfo.court_code} 
                                onChange={handleChange('court_code')} 
                                className={errorsForm.court_code ? 'inputError' : ''}
                                placeholder='' 
                                minLength='' 
                                maxLength='10' 
                                disabled={loading}
                                required />
                                {errorsForm.court_code && <div className='errorUnderInput'>{errorsForm.court_code}</div>}
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.bottom}>
                    <div>{status}</div>
                    <button 
                        type='button' 
                        className='button' 
                        onClick={handleSave}
                        disabled={loading}
                    >
                        {action=='add' && 'Добавить'} 
                        {action=='change' && 'Изменить'} 
                    </button>
                </div>
            </div>
        </div>
    )
}
